import React  from 'react';

import Invoice from './invoice'

export function InvoiceLayout({authUser}) {
    const [loading, setLoad] = React.useState(false);
    React.useEffect(() => {
        if (authUser) {
            setLoad(true)
        }
    }, [authUser]);
    return (
        < >
        {loading  ?
            < Invoice /> : ""  }                   
        </>
    )
}
